
import axios from 'axios';
import { sha256} from 'js-sha256';
import router from "../assets/js/route";
import store from '../assets/js/stateStore'
import {Message} from 'element-ui'
const headers = {
    token: '',
    timeStamp: '',
    randomUUID: '',
    authenticationStr: '',
    versionNum: '',
    terminalCode: '',
    systemCode: '',
};
console.log(process.env.API_HOST)
axios.defaults.baseURL = process.env.API_HOST;
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.transformRequest = [(data,headers)=> {
    let ret = ''
    for (let it in data) {
      let value = "";
      if(data[it]!=null &&  data[it] != 'null'){
        value= encodeURIComponent(data[it]);
      }
      ret += encodeURIComponent(it) + '=' + value + '&'
    }
    return ret
  }]

let systemCode = '004';
let versionNum = "1.0.0";
let platformCode = "3";
let terminalCode = "3";
axios.defaults.headers.common['systemCode'] = systemCode;
axios.defaults.headers.common['versionNum'] = versionNum;
axios.defaults.headers.common['platformCode'] = platformCode;
axios.defaults.headers.common['terminalCode'] = terminalCode;
headers.versionNum = versionNum;
headers.platformCode = platformCode;
headers.terminalCode = terminalCode;
headers.systemCode = systemCode;

axios.interceptors.request.use(function (config) {
    // console.log(config);
    if (config.url.indexOf("/api/uaa/sys/getTime") == -1) {
        let deviationSenconds = sessionStorage.getItem('deviationSenconds');
        if (deviationSenconds == null) {
            deviationSenconds = "0";
            store.commit("setSenconds", deviationSenconds);
            sessionStorage.setItem('deviationSenconds', deviationSenconds);
            freshTimeStamp();
        }
        let timeStamp = new Date(new Date().getTime() + parseInt(deviationSenconds)).format("yyyy-MM-dd hh:mm:ss");
        config.headers['timeStamp'] = timeStamp;
        config.headers['authenticationStr'] = sha256(systemCode + timeStamp);
        headers.timeStamp = timeStamp;
        headers.authenticationStr = sha256(systemCode + timeStamp);
    }

    if (store.state.userInfo != null) {
        config.headers['token'] = store.state.userInfo.token;
        headers.token = store.state.userInfo.token;
    }
    sessionStorage.setItem('headers', JSON.stringify(headers));
    return config;
});

axios.interceptors.response.use(function (response) {
    // console.log(response);
    if (response.status == 200) {
        if (response.data.code != undefined) {
            let code = response.data.code;
            if (code == '00003') {
                router.push("/login");
                return;
            }
            if (code != '00000') {
                Message({
                    message: response.data.msg,
                    type: 'error'
                });
            }
        }
        //返回未登录，页面跳转到登陆页面。
    }

    return response;
});


const instance = (url, data, fnSucc) => {
    var xhr = new XMLHttpRequest();

    xhr.open("post", process.env.API_HOST + url, true);
    xhr.setRequestHeader("token", headers.token);
    xhr.setRequestHeader("timeStamp", headers.timeStamp);
    xhr.setRequestHeader("randomUUID", headers.randomUUID);
    xhr.setRequestHeader("authenticationStr", headers.authenticationStr);
    xhr.setRequestHeader("platformCode", headers.platformCode);
    xhr.setRequestHeader("versionNum", headers.versionNum);
    xhr.setRequestHeader("terminalCode", headers.terminalCode);
    xhr.setRequestHeader("systemCode", headers.systemCode);

    xhr.send(data);

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                const data = JSON.parse(xhr.responseText);
                fnSucc(data);//成功的时候调用这个方法
            }
            else {
                if (fnfiled) {
                    fnField(xhr.status);
                }
            }
        }
    };
}
function freshTimeStamp() {
    axios.get("/api/uaa/sys/getTime").then(
        function (response) {
            let serverTime = new Date(response.data.time.replace(new RegExp("-", "gm"), "/"));
            let localTime = new Date();
            let deviationSenconds = serverTime.getTime() - localTime.getTime();
            store.commit("setSenconds", deviationSenconds);
            sessionStorage.setItem('deviationSenconds', deviationSenconds);
        }
    );
}
freshTimeStamp();

export {
    instance,
    axios
}


// WEBPACK FOOTER //
// ./src/api/axios.js